export interface IChunkType {
	id: number;
	name: string;
	admin: boolean;
}

// If you want to add more chunk types add it also to translations

export const CHUNK_TYPES: Record<number, IChunkType> = {
	1: {
		id: 1,
		name: 'title',
		admin: true,
	},
	2: {
		id: 2,
		name: 'text',
		admin: true,
	},
	3: {
		id: 3,
		name: 'image',
		admin: true,
	},
	4: {
		id: 4,
		name: 'video',
		admin: true,
	},
	5: {
		id: 5,
		name: 'scorm',
		admin: true,
	},
	6: {
		id: 6,
		name: 'formula',
		admin: true,
	},
	7: {
		id: 7,
		name: 'file',
		admin: true,
	},
	8: {
		id: 8,
		name: 'student',
		admin: true,
	},
	9: {
		id: 9,
		name: 'dictaphone',
		admin: true,
	},
	10: {
		id: 10,
		name: 'media',
		admin: true,
	},
};

enum ChunkTypes {
	TITLE = 'title',
	TEXT = 'text',
	IMAGE = 'image',
	VIDEO = 'video',
	SCORM = 'scorm',
	FORMULA = 'formula',
	FILE = 'file',
	STUDENT = 'student',
	DICTAPHONE = 'dictaphone',
	MEDIA = 'media',
}

export enum ChunkTypesId {
	'title' = 1,
	'text' = 2,
	'image' = 3,
	'video' = 4,
	'scorm' = 5,
	'formula' = 6,
	'file' = 7,
	'student' = 8,
	'dictaphone' = 9,
	'media' = 10,
}

export type ChunkType = `${ChunkTypes}`;

export const FORM_CHUNK_TYPES = [ChunkTypes.STUDENT, ChunkTypes.DICTAPHONE] as string[];

export default ChunkTypes;
